/** One draft Retry all could not finalize, as invoice-api's retryFailedFinalizations reports it. */
export interface BlockedDraft {
  vendor: string | null;
  reason: string;
}

/** The words the summary needs, already in the screen's language. */
export interface BlockedSummaryWords {
  line: (document: string, reason: string) => string;
  unnamed: string;
  more: (count: number) => string;
  reason: (raw: string) => string;
}

const SHOWN = 3;

/**
 * Why Retry all left drafts unfinished, one line per draft ("Office Supplies AB: No fiscal year
 * found …"), so the consultant does not have to open each one to find out. A long list is cut to
 * the first few and the rest counted.
 */
export function retryBlockedSummary(blocked: BlockedDraft[], words: BlockedSummaryWords): string[] {
  const lines = blocked
    .slice(0, SHOWN)
    .map((draft) => words.line(draft.vendor?.trim() || words.unnamed, words.reason(draft.reason)));
  if (blocked.length > SHOWN) lines.push(words.more(blocked.length - SHOWN));
  return lines;
}
